import React from "react";
import { useNavigate } from "react-router-dom";
import "./EventsPage.css";
import InnerFlyer from "../Assets/images/Inneleadership.jpeg";
import RippleRunFlyer from "../Assets/images/start.jpg";
import BookFair from "../Assets/images/book.jpeg";
import StoryFlyer from "../Assets/images/StoryFest.jpeg";

const eventsData = [
  {
    id: 1,
    title: "StoryFest 2026",
    subtitle: "Annual Storytelling & Creativity Festival",
    description: "A vibrant celebration of African storytelling featuring renowned authors, poets, and creative minds from across the continent.",
    image: StoryFlyer,
    date: "2026-12-11",
    time: "10:00 AM - 6:00 PM",
    venue: "Accra, Ghana",
    category: "Publishing",
    featured: false
  },
  {
    id: 2,
    title: "International Book Fair",
    subtitle: "Annual Storytelling & Creativity Festival",
    description: "An international gathering of publishers, authors, and book lovers showcasing the best in literature from around the world.",
    image: BookFair,
    date: "2026-08-27",
    time: "9:00 AM - 5:00 PM",
    venue: "National Theatre, Accra, Ghana",
    category: "Publishing",
    featured: false
  },
  {
    id: 3,
    title: "Ripple Run Marathon 2026",
    subtitle: "Ripple Run, One Step. Many Lives.",
    description: "Ripple Run is an annual event that gathers people from all walks of life to participate in a run for a cause.",
    image: RippleRunFlyer,
    date: "2026-06-13",
    time: "6:00 AM - 12:00 Noon",
    venue: "University of Ghana Sports Stadium, VIP Car Park",
    category: "Marathon"
  },
  {
    id: 4,
    title: "Inner Leadership Program",
    subtitle: "Keynote Speaker: Charles Hogg, Brahma Kumaris Australia (National Coordinator)",
    description: "The journey within is the beginning of true leadership. Lead yourself, and you can lead the world.",
    image: InnerFlyer,
    date: "2026-05-26",
    time: "10:00 AM - 12:00 Noon",
    venue: "Ample House, Accra, Ghana",
    category: "Leadership"
  }
];

const EventsPage = () => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  // Dynamic status checker based on current date
  const getEventStatus = (eventDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of day
    
    const eventDateObj = new Date(eventDate);
    eventDateObj.setHours(0, 0, 0, 0); // Reset time to start of day
    
    if (eventDateObj < today) {
      return "past";
    } else if (eventDateObj.getTime() === today.getTime()) {
      return "ongoing";
    } else {
      return "upcoming";
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      upcoming: { label: "Coming Soon", className: "badge-upcoming" },
      ongoing: { label: "Ongoing Today", className: "badge-ongoing" },
      past: { label: "Passed", className: "badge-past" }
    };
    return badges[status] || badges.upcoming;
  };

  const handleLearnMore = () => {
    navigate("/contact-us");
  };

  return (
    <div className="events-page">

      {/* HEADER */}
      <div className="events-header">
        <span className="events-label">✦ Events</span>
        <h1 className="events-title">Past & Upcoming Events</h1>
        <p className="events-subtitle">
          Explore transformative experiences designed to develop leaders, 
          foster creativity, and build community.
        </p>
      </div>

      {/* EVENTS GRID */}
      <div className="events-grid-wrapper">
        <div className="events-grid">
          {eventsData.map((event) => {
            // Get dynamic status based on date
            const eventStatus = getEventStatus(event.date);
            const statusBadge = getStatusBadge(eventStatus);
            
            return (
              <div 
                key={event.id} 
                className={`event-card ${event.featured ? "featured" : ""}`}
              >
                <div className="event-card-image">
                  <img src={event.image} alt={event.title} />
                  <div className={`event-status-badge ${statusBadge.className}`}>
                    {statusBadge.label}
                  </div>
                  {event.featured && (
                    <div className="event-featured-badge">⭐ Featured</div>
                  )}
                </div>

                <div className="event-card-content">
                  <div className="event-card-meta">
                    <span className="event-category">{event.category}</span>
                    <span className="event-date">{formatDate(event.date)}</span>
                  </div>

                  <h3 className="event-card-title">{event.title}</h3>
                  <p className="event-card-subtitle">{event.subtitle}</p>

                  <div className="event-card-details">
                    <div className="event-detail">
                      <span className="detail-icon">📍</span>
                      <span>{event.venue}</span>
                    </div>
                    <div className="event-detail">
                      <span className="detail-icon">🕐</span>
                      <span>{event.time}</span>
                    </div>
                  </div>

                  <button 
                    className="btn-learn-more"
                    onClick={handleLearnMore}
                  >
                    Learn More →
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

    </div>
  );
};

export default EventsPage;